import { Grid, useMediaQuery } from '@mui/material'
import React, { useContext, useEffect } from 'react'
import EmptyState from '../../global/emptyState'
import GlobalButton from '../../utility/globalButton/button'
import IconsColor from '../../utility/iconsColor'
import globalStyles from '../../../assets/styles/global.module.scss';
import styles from '../../../assets/styles/componentStyles/voiceAgentStyles/voiceAgent.module.scss'
import { useVoiceAgentStore } from '../../../store/voiceAgentStore'
import { useNavigate } from 'react-router-dom'
import emptyContactListImage from "../../../assets/images/voiceAgent/noVoiceAgents.png";
import { UserContext, UserContextPayload } from '../../../context/userContext'
import VoiceAgentListCard from './voiceAgentListCard'
import GlobalDeletePopup from '../../utility/globalDeletePopup/globalDeletePopup'
import agent from '../../../services/api'
import { hasVoiceAgentManagePermission } from '../../../utils/constants'
import { whiteColor } from '../../../utils/colors'
import { useGenericStore } from '../../../store/genericStore'
import { useShallow } from 'zustand/react/shallow'

const VoiceAgentList = () => {
    const { setFlagLoading, handleError, apiRoutesPermissionAssignment, userDetail } = useContext(UserContext) as UserContextPayload;

    const getVoiceAgentListAPI = useVoiceAgentStore((state) => state.getVoiceAgentListAPI);
    const voiceAgentList = useVoiceAgentStore((state) => state.voiceAgentList);
    const flagDeleteAgentPopup = useVoiceAgentStore((state) => state.flagDeleteAgentPopup);
    const setFlagDeleteAgentPopup = useVoiceAgentStore((state) => state.setFlagDeleteAgentPopup);
    const deleteVoiceAgentData = useVoiceAgentStore((state) => state.deleteVoiceAgentData);
    const setDeleteVoiceAgentData = useVoiceAgentStore((state) => state.setDeleteVoiceAgentData);
    
    const { showSuccess } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess
    })))

    const navigate = useNavigate()
    const innerHeight = (window.innerHeight - 105);
    
    const breakPoints = {
        smallScreen: useMediaQuery<boolean>('(max-width : 600px) and (min-width : 0px)'),
        flagTabletScreen: useMediaQuery<boolean>('(max-width : 900px) and (min-width : 600px)'),
        flagSmallScreen: useMediaQuery<boolean>('(min-width: 0px) and (max-width: 1000px)'),
    }

    const getVoiceAgentListAPICall = async () => {
        setFlagLoading((prev) => ({...prev, flagRoundLoader: true}));
        const res = await getVoiceAgentListAPI();
        if(!(res.status)){
            handleError(res);
        }
        setFlagLoading((prev) => ({...prev, flagRoundLoader: false}));
    }

    useEffect(() => {
        getVoiceAgentListAPICall();
    }, []); 

    const handleAddNewAgent = () => {
        navigate(`/voiceagent/createvoiceagent`)
    }

    const deleteVoiceAgent = async () => {
        setFlagLoading((prev) => ({...prev, flagRoundLoader: true}));
        const res = await agent.deleteVoiceAgent.delete(deleteVoiceAgentData?.voice_agent_id || "");
        if (res.status) {
            showSuccess("Voice Agent Deleted Successfully!")
            getVoiceAgentListAPICall()
        }
        else {
            handleError(res);
        }
        setFlagLoading((prev) => ({...prev, flagRoundLoader: false}));
    
    }

    return (
        <Grid container className={styles.createVoiceAgentContainer} sx={{height: `${innerHeight}px !important`, maxHeight: `${innerHeight}px`}} padding={"12px 0px"}>
            {voiceAgentList && voiceAgentList.length === 0 ?
                <Grid item className={globalStyles.fullwidth}>
                    <EmptyState
                        height={breakPoints.flagTabletScreen ? 'calc(100vh - 150px)' : 'calc(100vh - 125px)'}
                        pageIcon={<img alt="chatbot" src={emptyContactListImage} style={{ width: "165px", height: "auto" }} />}
                        pageSubText={"No Voice Agent Created Yet"}
                        primaryActionBtn={
                            <>
                                {hasVoiceAgentManagePermission(apiRoutesPermissionAssignment, userDetail) && 
                                    <GlobalButton
                                        buttonText={"New Agent"}
                                        className='primaryButtonStyle'
                                        sx={{ width: "150px" }}
                                        startIcon={<IconsColor iconName="plus" width="15px" height="15px" fillColor={whiteColor} />}
                                        onClick={() => { handleAddNewAgent() }}
                                    />
                                }
                            </>
                        }
                    />
                </Grid>
                :
                <Grid item className={`${globalStyles.fullwidth} ${styles.voiceListStyle}`}>
                    <Grid container gap={"20px"} alignItems={"center"}>
                        {voiceAgentList?.map((agent, ind) => {
                            return <VoiceAgentListCard agent={agent} />
                        })}
                    </Grid>
                </Grid>
            }

            {flagDeleteAgentPopup &&
                <GlobalDeletePopup
                    deleteDescription={`Are you sure you want to delete ${deleteVoiceAgentData?.voice_agent_name} agent`}
                    open={flagDeleteAgentPopup}
                    onClose={() => { setFlagDeleteAgentPopup(false); setDeleteVoiceAgentData(null) }}
                    onDelete={() => {
                        deleteVoiceAgent()
                        setFlagDeleteAgentPopup(false);
                        setDeleteVoiceAgentData(null);
                    }}
                />
            }
        </Grid>
    )
}

export default VoiceAgentList